const singleThumbs = document.querySelector('.single-product__thumbnails');
const singleGallerySelector = '.single-product__gallery-main:not(.swiper-initialized)';
const singleThumbnailsSelector = '.single-product__thumbnails:not(.swiper-initialized)';

var swiper2 = new Swiper(singleThumbnailsSelector, {
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: 16,
    speed: 250,
    freeMode: true,
    watchSlidesProgress: true
});

var swiper = new Swiper(singleGallerySelector, {
    slidesPerView: 'auto',
    speed: 500,
    loop: true,
    pagination: {
        el: '.single-product__gallery-pagination',
        clickable: true,
    },
    thumbs: {
        swiper: swiper2,
    }
});
